import React, { useRef, useEffect, useState } from 'react';

const reviews = [
  {
    name: 'Wannie Johannes van Aerle',
    text: 'Topservice bij Vermado! Voor mijn Audi RS3 ABT wilde ik graag een Eventuri intake laten plaatsen. Alles netjes en professioneel afgehandeld.',
    stars: 5,
    platform: 'google' as const,
  },
  {
    name: 'Wouter',
    text: 'Twee jaar geleden mijn S213 E63S AMG onder handen laten nemen door Vermado, stage 2. Beast unlocked! Geweldig werk geleverd. Ook de service is echt perfect, ze staan altijd voor je klaar. Bovendien zijn het allemaal enorm aardige mensen.',
    stars: 5,
    platform: 'google' as const,
  },
  {
    name: 'Makoto Gym',
    text: 'Wat een geweldig team! Vermado en Brex vullen elkaar goed aan en zijn echte vakmensen. Kan iedereen die trots is op zijn bolide aanraden om met dit bedrijf samen te werken. Altijd vriendelijk, eerlijk, goede service en echte techneuten die het snappen.',
    stars: 5,
    platform: 'google' as const,
  },
  {
    name: 'Mark Verkerk',
    text: 'Wat een wereldbedrijf is Vermado!! Wat een service en hulp, waar maak je dat nog mee? Mijn RS6 tot in de puntjes gefinetuned en zo veel extra service! Echt een 10 voor jullie! Bedankt!!!',
    stars: 5,
    platform: 'google' as const,
  },
  {
    name: 'Borislav Lekić',
    text: 'Lang opzoek geweest naar een bedrijf die mijn auto kan chippen, beter geluid en een beter uiterlijk kan geven. Na contact opgenomen te hebben met Vermado ben ik daar langs gegaan. Top resultaat.',
    stars: 5,
    platform: 'google' as const,
  },
  {
    name: 'Rianne S',
    text: 'Mijn Polo GTI stage 1 laten chippen en een Milltek catback laten monteren. Erg goed geholpen door Maarten. Via WhatsApp op de hoogte gehouden. Gratis leenauto meegekregen. Echt top!',
    stars: 5,
    platform: 'google' as const,
  },
  {
    name: 'Bryan Javaux',
    text: 'Na aankoop van een Audi RS6 C8 moesten er wat zaken aangepakt worden. Ik heb Vermado opgebeld en kon diezelfde dag nog terecht om samen een plan van aanpak te maken.',
    stars: 5,
    platform: 'google' as const,
  },
  {
    name: 'Raymond Martens',
    text: 'Maarten en zijn collega\'s hebben met veel aandacht gewerkt aan mijn VW Touareg R. De auto rijdt soepeler en gaat een stuk rapper van zijn plek.',
    stars: 5,
    platform: 'google' as const,
  },
  {
    name: 'Melvin Jellesma',
    text: 'Erg onder de indruk van snelheid communicatie. Service. Afterservice. Alles klopt hier. Beveel ze van harte aan.',
    stars: 5,
    platform: 'google' as const,
  },
  {
    name: 'Youp Havik',
    text: 'Echte vakmensen! Het adres voor specialistische en exclusieve auto\'s.',
    stars: 5,
    platform: 'google' as const,
  },
  {
    name: 'Jurgen Hesselink',
    text: 'Vakmensen met veel verstand van zaken, als je high end tuning zoekt ben je hier aan het juiste adres!',
    stars: 5,
    platform: 'google' as const,
  },
  {
    name: 'Marcel Waldram',
    text: 'Zeer goede service, veel kennis en ervaring op zijn vakgebied!',
    stars: 5,
    platform: 'google' as const,
  },
];

const Stars = ({ count }: { count: number }) => (
  <div className="flex gap-0.5">
    {[...Array(5)].map((_, i) => (
      <svg key={i} className={`w-[18px] h-[18px] ${i < count ? 'text-black' : 'text-black/20'}`} viewBox="0 0 20 20" fill="currentColor">
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
    ))}
  </div>
);

const GoogleBadge = () => (
  <div className="flex items-center gap-1.5 border border-black/10 rounded-full px-3 py-1.5">
    <span className="text-[11px] font-medium text-black/50" style={{ fontFamily: "'Manrope', sans-serif" }}>Google</span>
    <svg className="w-3.5 h-3.5" viewBox="0 0 24 24">
      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
    </svg>
  </div>
);

const ReviewsCarousel = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft = 100;
    }
  }, []);

  useEffect(() => {
    if (!scrollRef.current) return;
    let animationId: number;
    let speed = 0.5;

    const autoScroll = () => {
      if (!scrollRef.current || isDragging) {
        animationId = requestAnimationFrame(autoScroll);
        return;
      }
      scrollRef.current.scrollLeft += speed;
      if (scrollRef.current.scrollLeft >= scrollRef.current.scrollWidth - scrollRef.current.clientWidth) {
        scrollRef.current.scrollLeft = 0;
      }
      animationId = requestAnimationFrame(autoScroll);
    };

    animationId = requestAnimationFrame(autoScroll);
    return () => cancelAnimationFrame(animationId);
  }, [isDragging]);

  const handleMouseDown = (e: React.MouseEvent) => {
    setIsDragging(true);
    setStartX(e.pageX - (scrollRef.current?.offsetLeft || 0));
    setScrollLeft(scrollRef.current?.scrollLeft || 0);
  };

  const handleMouseMove = (e: React.MouseEvent) => {
    if (!isDragging || !scrollRef.current) return;
    e.preventDefault();
    const x = e.pageX - (scrollRef.current.offsetLeft || 0);
    const walk = (x - startX) * 1.5;
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleMouseUp = () => setIsDragging(false);

  return (
    <section className="bg-white py-20 md:py-28 lg:py-32 overflow-hidden">
      <div
        ref={scrollRef}
        className="flex gap-0 overflow-x-auto cursor-grab active:cursor-grabbing scrollbar-hide"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none', paddingLeft: '4vw', paddingRight: '4vw' }}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
      >
        {reviews.map((review, i) => (
          <div
            key={i}
            className="flex-shrink-0 w-[280px] md:w-[300px] flex flex-col select-none pr-8"
            style={{ minHeight: '420px' }}
          >
            <div>
              <h3
                className="text-black font-bold text-[14px] mb-4"
                style={{ fontFamily: "'Manrope', sans-serif" }}
              >
                {review.name}
              </h3>
              <p
                className="text-black text-[13.5px] leading-[1.8]"
                style={{ fontFamily: "'Manrope', sans-serif" }}
              >
                {review.text}
              </p>
            </div>

            <div className="border-t border-black/15 mt-auto pt-5">
              <div className="flex items-center justify-between">
                <Stars count={review.stars} />
                <GoogleBadge />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ReviewsCarousel;
